import { render } from "./ShowAlerts.vue?vue&type=template&id=39a517f8&scoped=true"
import script from "./ShowAlerts.vue?vue&type=script&lang=js"
export * from "./ShowAlerts.vue?vue&type=script&lang=js"

import "./ShowAlerts.vue?vue&type=style&index=0&id=39a517f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a517f8"]])

export default __exports__